import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseMutationResult,
  UseQueryResult,
} from 'react-query';
import { ReactQueryKeys } from 'enums';

export interface ApprovalPolicy {
  enabled: boolean;
  pendingRequestType: string | null;
  activeAdminCount: number;
}

export const useApprovalPolicy = (): UseQueryResult<ApprovalPolicy> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery(ReactQueryKeys.ApprovalPolicy, async () => {
    const { data } = await treasureApi().get<ApprovalPolicy>(
      '/approval-policy',
    );

    return {
      enabled: Boolean(data.enabled),
      pendingRequestType: data.pendingRequestType ?? null,
      activeAdminCount: data.activeAdminCount ?? 0,
    };
  });
};

export const useUpdateApprovalPolicy = (): UseMutationResult<
  void,
  unknown,
  { enabled: boolean }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const updateApprovalPolicy = async ({ enabled }: { enabled: boolean }) => {
    // A successful response, including 202, means the change is pending.
    await treasureApi().put('/approval-policy', { enabled });
  };

  return useMutation(updateApprovalPolicy, {
    onSuccess: () => {
      queryClient.refetchQueries(ReactQueryKeys.ApprovalPolicy);
    },
  });
};
